<template>
  <router-view>
  </router-view>
</template>

<script>
export default {
  name: 'app',
  created () {
    this.$store.dispatch('setUserToken')
    this.$store.dispatch('setUserRole')
  }
}
</script>

<style lang="scss">
*,
body {
  font-family: 'Open Sans', sans-serif;
}

.title {
  font-weight: 300;
}

b,
.label {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// App.vue?4b4a375c